<template>
  <div class="notification-skeleton">
    <div class="icon-skeleton shimmer"></div>
    <div class="text-skeleton">
      <div class="line short shimmer"></div>
      <div class="line long shimmer"></div>
    </div>
  </div>
</template>

<style scoped>
.notification-skeleton {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 0;
}

.icon-skeleton {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--skeleton-bg);
  flex-shrink: 0;
}

.text-skeleton {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.line {
  height: 12px;
  border-radius: 6px;
  background: var(--skeleton-bg);
}

.line.short {
  width: 50%;
}

.line.long {
  width: 80%;
}

.shimmer {
  position: relative;
  overflow: hidden;
}
.shimmer::before {
  content: "";
  position: absolute;
  top: 0;
  left: -150px;
  height: 100%;
  width: 150px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    var(--skeleton-shimmer) 50%,
    transparent 100%
  );
  animation: shimmer 1.2s infinite;
}

@keyframes shimmer {
  100% {
    transform: translateX(300px);
  }
}

:root {
  --skeleton-bg: #eeeeee;
  --skeleton-shimmer: #f6f6f6;
}

[data-theme="dark"] {
  --skeleton-bg: #2e2e2e;
  --skeleton-shimmer: #3a3a3a;
}
</style>